<script setup lang="ts">
	/**
	 * @author Beka Chkhaidze
	 */
	import { ref, watch } from "vue";
	
	import { useNumIncrement } from "@/composables/utils/numIncrement";
	import type { ToolTipInterface } from "@/types/ContentType";

	const props = defineProps<{
		item: ToolTipInterface;
		percentage: string;
		delay: number;
		templateKey: number;
	}>();

	const templateRef = ref<HTMLElement>();
	const width = ref(0);
	const TRANSITION_DURATION = 4000;
	let id: number;

	watch(
		() => props.templateKey,
		async () => {
			window.cancelAnimationFrame(id);
			// templateRef.value!.textContent = "$ 0";

			setTimeout(() => {
				width.value = templateRef.value?.clientWidth || 0;

				id = useNumIncrement({
					element: templateRef.value!,
					end: Number(props.item.amount),
					innerTextPrefix: "$ ",
					duration: 3400,
				});
			}, 400);
		}
	);
</script>

<template>
	<li
		class="project-forecast__chart-item pos-rel"
		:style="`--duration: ${TRANSITION_DURATION}ms; --width: ${percentage}%`"
	>
		<div class="line pos-rel">
			<div class="price-wrapper ov-hidden">
				<p ref="templateRef">$ {{ item?.amount || 0 }}</p>
			</div>
			<div class="line-in" />
		</div>

		<div class="month pos-abs">{{ $t(item.month!?.toLowerCase()) }}</div>
		<div class="count pos-abs">{{ item.rentQuantity }}</div>
	</li>
</template>
